import { useEffect, useMemo } from 'react'

import type { Mode } from 'core/domain/Mode'
import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import type { AccessorialOption } from '../../domain/ShipmentCharges'
import { getPriceItemTypes } from '../../use-cases/getPriceItemTypes'

export function useShipmentPriceItemTypes({ mode, enabled }: { mode: Mode; enabled: boolean }) {
  const { call, reset, result, status } = useAsync(getPriceItemTypes)
  const abortController = useAbortController()

  useEffect(() => {
    if (enabled) {
      call(mode, 'shipment', abortController)
    } else {
      reset()
    }
  }, [call, reset, enabled, mode, abortController])

  const priceItemTypes: Array<AccessorialOption> = useMemo(
    () =>
      (result ?? []).map(priceItemType => ({
        label: priceItemType.label,
        value: priceItemType.uuid,
        stopsRelationship: priceItemType.stopsRelationship,
      })),
    [result]
  )

  return {
    priceItemTypes,
    priceItemTypesStatus: status,
  }
}
